import dbList from "../DBList.json";
import fetchWithTimeout from "./fetchWithTimeout";

const {
    api_server,
    auth
} = dbList.server;

export async function Login(AUserID, APassword) {
    const httpRes = await fetchWithTimeout(`${api_server}${auth}/login`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*",
            "content-type": "application/json"
        },
        body: JSON.stringify({
            userId: AUserID,
            password: APassword
        })
    });

    if (httpRes.status !== 200)
        throw new Error(await httpRes.text());

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw new Error(result.message);
    }

    return result;
}

export async function Logout() {
    const httpRes = await fetchWithTimeout(`${api_server}${auth}/logout`, {
        method: "DELETE",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status !== 200)
        throw new Error(await httpRes.text());
}

export async function VerifySession() {
    const httpRes = await fetchWithTimeout(`${api_server}${auth}/verify`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status === 500) {
        throw new Error(await httpRes.text());
    } else if (httpRes.status === 401) {
        return false;
    }        

    const result = await httpRes.text();

    return result === "OK";
}
